var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VcLayout',{attrs:{"flex-grow-0":""}},[_c('VcPageHeader',{attrs:{"title":_vm.$t('point_of_sale.page_title'),"subtitle":_vm.$t('point_of_sale.page_subtitle'),"show-back-button":_vm.showBackButton,"data-qa":"pos-page-header"},on:{"onBackClicked":_vm.onBackClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }